import { useCallback } from 'react';
import {
  useMessageDispatch,
  UseMessageDispatchProps,
} from './useEddyMessaging';

export type UseContextMenuMessagingProps = Pick<
  UseMessageDispatchProps,
  'iframe'
>;

export function useContextMenuMessaging({
  iframe,
}: UseContextMenuMessagingProps) {
  const dispatch = useMessageDispatch({ iframe });

  const closeContextMenu = useCallback(() => {
    dispatch({ type: 'contextMenuClose' });
  }, [dispatch]);

  return { closeContextMenu };
}
